module.exports = __webpack_public_path__ + "static/media/main idea.925f61b8.mp3";